/**
 * Created by Jonas Wålekvist on 2017-11-29.
 */

import {GameIntroView, IGameIntroViewConfig} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TeslaGameAssets} from "../TeslaGameAssets";


export class TeslaIntroView extends GameIntroView {
    private _portraitBackground:PIXI.Sprite;
    private _landscapeBackground:PIXI.Sprite;
    private _introBonus:PIXI.Sprite;
    private _introScatter:PIXI.Sprite;
    private _introFsWild:PIXI.Sprite;
    private _introBonusText:PIXI.Sprite;
    private _introScatterText:PIXI.Sprite;
    private _introFsWildText:PIXI.Sprite;
    private _isIPad:boolean;
    private _isIPadLandscape:boolean;

    constructor(config:IGameIntroViewConfig) {
        super(config);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._landscapeBackground = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_BACKGROUND_LANDSCAPE)[0]);
        this._landscapeBackground.anchor.set(0.5, 0.5);
        this._portraitBackground = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_BACKGROUND_PORTRAIT)[0]);
        this._portraitBackground.anchor.set(0.5, 0.5);

        this._portraitBackground = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_BACKGROUND_PORTRAIT)[0]);
        this._portraitBackground.anchor.set(0.5, 0.5);

        this._introBonus = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_BONUS)[0]);
        this._introBonus.anchor.set(0.5, 0.5);

        this._introScatter = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_SCATTER)[0]);
        this._introScatter.anchor.set(0.5, 0.5);

        this._introFsWild = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_FS_WILD)[0]);
        this._introFsWild.anchor.set(0.5, 0.5);

        this._introBonusText = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_BONUS_TEXT)[0]);
        this._introBonusText.anchor.set(0.5, 0.5);

        this._introScatterText = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_SCATTER_TEXT)[0]);
        this._introScatterText.anchor.set(0.5, 0.5);

        this._introFsWildText = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.INTRO_FS_WILD_TEXT)[0]);
        this._introFsWildText.anchor.set(0.5, 0.5);

        this.addChild(this._background);
        this.addChild(this._landscapeBackground);
        this.addChild(this._portraitBackground);
        this.addChild(this._brandText);
        this.addChild(this._button);
        this.addChild(this._introBonus);
        this.addChild(this._introScatter);
        this.addChild(this._introFsWild);
        this.addChild(this._introBonusText);
        this.addChild(this._introScatterText);
        this.addChild(this._introFsWildText);
    }


    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);

        this._isIPad = resizeData.width / resizeData.height >= 0.73 || resizeData.width / resizeData.height >= 4 / 3;
        this._isIPadLandscape = resizeData.width / resizeData.height <= 1.35 || resizeData.width / resizeData.height <= 4 / 3;
        this._portraitBackground.visible = resizeData.orientation == Orientation.PORTRAIT;
        this._landscapeBackground.visible = resizeData.orientation == Orientation.LANDSCAPE;
        this._portraitBackground.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._landscapeBackground.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        if(resizeData.orientation == Orientation.PORTRAIT) {
            this.getPortrait(resizeData);

        } else {
            this.getLandscape(resizeData);
        }
    }

    private getPortrait(data:IResizeData) {
        const windowScaleX:number = (data.width / 720);
        const windowScaleY:number = (data.height / 1280);
        const scale = Math.max(windowScaleX, windowScaleY) / this._layer.scale.x;
        this._portraitBackground.scale.set(scale, scale);


        this._introBonus.position.set(this._screenWidth * 0.4, this._screenHeight * 0.25);
        this._introBonus.scale.set(1, 1);
        this._introBonusText.position.set(this._screenWidth * 0.55, this._screenHeight * 0.30);

        this._introScatter.position.set(this._screenWidth * 0.32, this._screenHeight * 0.62);
        this._introScatter.scale.set(1, 1);
        this._introScatterText.position.set(this._screenWidth * 0.18, this._screenHeight * 0.47);

        this._introFsWild.position.set(this._screenWidth * 0.83, this._screenHeight * 0.45);
        this._introFsWild.scale.set(1, 1);
        this._introFsWildText.position.set(this._screenWidth * 0.65, this._screenHeight * 0.52);
    }

    private getLandscape(data:IResizeData) {

        const windowScaleX:number = (data.width / 1280);
        const windowScaleY:number = (data.height / 720);
        const scale = Math.max(windowScaleX, windowScaleY) / this._layer.scale.x;
        this._landscapeBackground.scale.set(scale, scale);

        this._introBonus.position.set(this._screenWidth * 0.20, this._screenHeight * 0.30);
        this._introBonus.scale.set(0.9, 0.9);
        this._introBonusText.position.set(this._screenWidth * 0.28, this._screenHeight * 0.38);
        this._introBonus.scale.set(0.9, 0.9);

        this._introScatter.position.set(this._screenWidth * 0.80, this._screenHeight * 0.50);
        this._introScatter.scale.set(0.9, 0.9);
        this._introScatterText.position.set(this._screenWidth * 0.74, this._screenHeight * 0.27);
        this._introBonus.scale.set(0.9, 0.9);

        this._introFsWild.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._introFsWild.scale.set(0.9, 0.9);
        this._introFsWildText.position.set(this._screenWidth * 0.41, this._screenHeight * 0.61);
        this._introBonus.scale.set(0.9, 0.9);
    }
}